export default "__VITE_ASSET__BEMlvGZE__"